import React from 'react'
import styled from 'styled-components'
import { withScope, captureException } from '@sentry/browser'
import { KachingLogo } from '../rewards-ui/components/Icons/KachingLogo'

const Wrapper = styled.div`
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 12px;
`

const Message = styled.div``

export class ErrorBoundary extends React.Component {
	state = {
		hasError: false,
		error: undefined,
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, message: error }
	}

	componentDidCatch(error, errorInfo) {
		withScope(scope => {
			scope.setExtras(errorInfo)
			captureException(error)
		})
	}

	render() {
		const { hasError, error } = this.state
		const { children } = this.props
		if (hasError) {
			return (
				<Wrapper>
					<KachingLogo height={80} />
					<Message>{error || 'Error'}</Message>
				</Wrapper>
			)
		}

		return children
	}
}
